import { useCallback } from 'react'

import Button from '@/components/ui/Button'
import { StepComponentProps } from '../types'
import { showToast, ToastType } from '@/features/toast'
import { useLingui } from '@lingui/react/macro'

function startPopupFlow(url: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const popup = window.open(url, 'popup', 'width=500,height=600')

    const messageListener = (event: MessageEvent) => {
      // Safety check: only listen to your own domain
      if (event.origin !== window.location.origin) return

      if (event.data.type === 'POPUP_COMPLETE') {
        window.removeEventListener('message', messageListener)
        resolve()
      }
    }

    window.addEventListener('message', messageListener)

    // Watch for manual window closure
    const timer = setInterval(() => {
      if (popup?.closed) {
        clearInterval(timer)
        reject()
      }
    }, 500)
  })
}

export function PopupLinkComponent({ step, onReload }: StepComponentProps) {
  const { t } = useLingui()

  const onOpen = useCallback(() => {
    if (!step.link) return

    startPopupFlow(step.link)
      .then(onReload)
      .catch(() => {
        showToast({
          id: 'popup-error',
          type: ToastType.ERROR,
          message: t`There was an error unexpected Error in the PopUp`
        })
      })
  }, [step.link, onReload, t])

  if (!step.link) return null

  return (
    <div className="flex flex-col gap-2 p-4">
      <h1 className="text-heading1 text-text">{step.title}</h1>
      {step.description && (
        <p className="text-regular text-text">{step.description}</p>
      )}
      <div className="p-4">
        <Button onClick={onOpen} className="w-full">
          {step.linkTitle}
        </Button>
      </div>
    </div>
  )
}
